export default function NotFoundPage() {
  return (
    <div>
      <p>404 Not Found</p>
    </div>
  );
}
